import { useMutation } from '@tanstack/react-query';
import { authService } from 'shared/src/api';

export const usePostValidateEmailAuth = () => {
  return useMutation({
    mutationFn: authService.postValidateEmailAuth,
    throwOnError: false,
  });
};
